import { useEffect, useState } from "react";

import { Typography } from "@mui/material";

import { LINKED_TRANSACTION_OPTIONS } from "appConfig";

import { LineItemSelectScalar } from "components/formFields/LineItemSelectScalar";
import { LineItemTextField } from "components/formFields/LineItemTextField";
import { LineTableCell } from "components/formFields/LineTableCell";

import { i18n } from "services/i18nService";
import { formatLinkedTransaction } from "services/utility/list";

import { OBJECT_TYPES } from "appConstants";

export function LineLinkedTransactionSelect(props) {
  const {
    name,
    onValueChange,
    value: initialValue,
    objectType,
    lineReadOnly,
  } = props;

  const [value, setValue] = useState(formatLinkedTransaction(initialValue));

  useEffect(
    () => setValue(formatLinkedTransaction(initialValue)),
    [initialValue, name]
  );

  function handleValueChange(fieldName, newValue) {
    onValueChange("linkedTransaction", {
      ...value,
      [fieldName]: fieldName === "lineNumber" ? parseInt(newValue) : newValue,
    });
  }

  const isPayment = objectType === OBJECT_TYPES.PAYMENT.fullString;

  return (
    <LineTableCell sx={{ minWidth: "10rem" }}>
      <div style={{ display: "flex", alignItems: "center" }}>
        <div>
          <LineItemSelectScalar
            name="transactionType"
            options={LINKED_TRANSACTION_OPTIONS[objectType]}
            onValueChange={handleValueChange}
            value={value.transactionType}
            lineReadOnly={lineReadOnly}
            minWidth="6rem"
          />
        </div>
        <LineItemTextField
          name="refNumber"
          value={value.refNumber || ""}
          onValueChange={handleValueChange}
          lineReadOnly={lineReadOnly}
          width="8rem"
        />
        {!isPayment && (
          <>
            <Typography sx={{ whiteSpace: "nowrap", fontSize: "0.8125rem" }}>
              {i18n("global.LineNumber")}
            </Typography>
            <LineItemTextField
              number
              name="lineNumber"
              value={
                typeof value.lineNumber === "number" ? value.lineNumber : ""
              }
              onValueChange={handleValueChange}
              lineReadOnly={lineReadOnly}
              width="3.5rem"
            />
          </>
        )}
      </div>
    </LineTableCell>
  );
}
